import React from 'react';
import {
  cssColorValue,
  TypeList,
  TypeListItem,
  semanticColors,
  spacer20,
  spacer32,
  spacer8,
  Type,
} from '@spotify-internal/encore-web';
import styled from 'styled-components';

import PageContainer from 'components/PageContainer';
import IconChevron from 'components/IconChevron';
import { QuickLink } from 'lib/sanity/types';
import { useTranslation } from 'providers/translations/TranslationProvider';
import { ArticleLink } from 'components/Links';
import { UbiHomePage } from 'utils/ubi/pages/useUbiHome';

export const Container = styled.div`
  background-color: ${cssColorValue(semanticColors.backgroundElevatedHighlight)};
`;

export const StyledIconChevron = styled(IconChevron)`
  align-self: center; // Align in the middle of multi-line links
  margin-inline-start: ${spacer8};
  color: ${cssColorValue(semanticColors.textBase)};
`;

export const StyledArticleLink = styled(ArticleLink)`
  display: flex;
  justify-content: space-between;
  padding: ${spacer20} 0;
`;

export interface QuickLinksProps {
  quickLinks: QuickLink[];
  ubi: UbiHomePage;
}

const QuickLinks = ({ quickLinks, ubi }: QuickLinksProps) => {
  const { t } = useTranslation();

  if (!quickLinks.length) return null;

  return (
    <Container>
      <PageContainer data-testid="quickLinksContainer">
        <Type as="h2" variant="canon" paddingBottom={spacer32}>
          {t('quick_help')}
        </Type>
        <TypeList condensedAll listStyleReset>
          {quickLinks.map((quickLink, index) => (
            <TypeListItem key={quickLink.slug} variant="ballad" condensed listStyleReset>
              <StyledArticleLink
                slug={quickLink.slug}
                eventDefinition={{
                  category: 'top_solutions',
                  label: 'home_page',
                  action: quickLink.slug,
                }}
                standalone
                ubiFactory={ubi.logQuickLink(quickLink.slug, index)}
              >
                <Type variant="cello" semanticColor="textBase" weight="book">
                  {quickLink.title}
                </Type>
                <StyledIconChevron size={24} />
              </StyledArticleLink>
            </TypeListItem>
          ))}
        </TypeList>
      </PageContainer>
    </Container>
  );
};

export default QuickLinks;
